import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const TOP_METRICS = [{
  value: '+200',
  label: 'Clases listas'
}, {
  value: '+5000',
  label: 'Alumnas satisfechas'
}, {
  value: '3.800+',
  label: 'Horas ahorradas'
}, {
  value: '99%',
  label: 'Lo recomiendan'
}];
const BEFORE = ['Horas planificando cada clase', 'Clases repetitivas', 'Sin profundidad filosófica', 'No saber qué cobrar', 'Alumnos que se van'];
const AFTER = ['5 minutos de repaso', 'Clases con variedad', 'Tema filosófico cada semana', 'Precios claros y confianza', 'Comunidad fiel'];
const BOTTOM_STATS = [{
  value: '+200',
  label: 'Clases'
}, {
  value: '12',
  label: 'Tomos'
}, {
  value: '100%',
  label: 'Descargable'
}];
export function ImpactStats() {
  return <section className="bg-hueso" data-id="element-119" data-mp="3c2hkxi7vbs7z">
      {/* Top metrics bar */}
      <div className="bg-white border-b border-gray-100" data-id="element-120" data-mp="3757wo5w7tmlq">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 divide-x divide-gray-200" data-id="element-121" data-mp="1uuph75krpblm">
          {TOP_METRICS.map((metric, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="py-8 px-4 text-center" data-id="element-122" data-mp="1zrfwhqor035z" data-mpi={idx}>
              <div className="font-serif text-3xl md:text-5xl font-bold text-oscuro mb-1" data-id="element-123" data-mp="1kvi2of2arawx">
                {metric.value}
              </div>
              <div className="text-[11px] md:text-sm uppercase tracking-widest text-gray-500 font-medium" data-id="element-124" data-mp="1pwe5sqetqt1a">
                {metric.label}
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-6xl mx-auto px-4 py-16 md:py-24" data-id="element-125" data-mp="117qjeji3ok1r">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-126" data-mp="11a39jjy0i0pw">
          {/* Left: headline + highlight card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-127" data-mp="1b6pt85elqlqc">
            <h2 className="font-serif text-4xl md:text-6xl font-bold text-oscuro leading-[1.05] mb-8" data-id="element-128" data-mp="if63e2ni29fd">
              De una profesora sobrecargada a una{' '}
              <span className="italic text-salvia" data-id="element-129" data-mp="s83qkm3fsmkb">guía inspirada.</span>
            </h2>

            <div className="bg-white rounded-3xl shadow-soft p-6 md:p-8 flex items-center gap-5 max-w-md" data-id="element-130" data-mp="nfkc7mwxdneg">
              <span className="font-serif text-5xl md:text-6xl font-bold text-terracota leading-none" data-id="element-131" data-mp="3vv42qe67orpt">
                3.800+
              </span>
              <span className="text-gray-600 text-sm md:text-base leading-snug" data-id="element-132" data-mp="26f9vkty7vaiz">
                horas ahorradas al año en planificación.
              </span>
            </div>
          </motion.div>

          {/* Right: before / after card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="rounded-3xl border border-gray-100 shadow-soft overflow-hidden grid grid-cols-2" data-id="element-133" data-mp="1xfmw4dp1sesk">
            {/* Before */}
            <div className="bg-white p-6 md:p-8" data-id="element-134" data-mp="2l3o85wlfqdcq">
              <div className="flex items-center gap-2 mb-6" data-id="element-135" data-mp="2l2ctv2ud5n7d">
                <span className="w-6 h-6 rounded-full bg-terracota/10 text-terracota flex items-center justify-center" data-id="element-136" data-mp="14po90nueyrqj">
                  <X size={13} strokeWidth={3} data-id="element-137" data-mp="19pskfzggsw9w" />
                </span>
                <span className="text-xs md:text-sm font-bold uppercase tracking-widest text-terracota" data-id="element-138" data-mp="1oyxkuqnqt2oi">
                  Antes
                </span>
              </div>
              <ul className="space-y-4" data-id="element-139" data-mp="1f8uiw0yn8ee1">
                {BEFORE.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-140" data-mp="1f6i23r4mga2k" data-mpi={idx}>
                    <X size={16} className="text-terracota/60 flex-shrink-0 mt-0.5" data-id="element-141" data-mp="1b8u42f7mu16g" />
                    <span className="text-gray-600 text-sm md:text-[15px] leading-snug" data-id="element-142" data-mp="22you6e3bduw6">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-salvia-light/60 p-6 md:p-8" data-id="element-143" data-mp="1tx8v32hy9f79">
              <div className="flex items-center gap-2 mb-6" data-id="element-144" data-mp="ni7wsq5gckxi">
                <span className="w-6 h-6 rounded-full bg-salvia/20 text-salvia flex items-center justify-center" data-id="element-145" data-mp="nflqetuasbgv">
                  <Check size={13} strokeWidth={3} data-id="element-146" data-mp="2u5xg9npy3ata" />
                </span>
                <span className="text-xs md:text-sm font-bold uppercase tracking-widest text-salvia" data-id="element-147" data-mp="2u7ryuvdququ7">
                  Con Yoga 360
                </span>
              </div>
              <ul className="space-y-4" data-id="element-148" data-mp="335tz38pnlfgf">
                {AFTER.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-149" data-mp="37ydm0wa8dmxw" data-mpi={idx}>
                    <Check size={16} className="text-salvia flex-shrink-0 mt-0.5" strokeWidth={2.5} data-id="element-150" data-mp="3cwovv70izxg4" />
                    <span className="text-oscuro font-medium text-sm md:text-[15px] leading-snug" data-id="element-151" data-mp="3mumjbsak9q7o">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        {/* Bottom stat cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-12 md:mt-16 max-w-4xl mx-auto" data-id="element-152" data-mp="1wi6v0m42p5em">
          {BOTTOM_STATS.map((stat, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl shadow-soft py-8 px-4 text-center" data-id="element-153" data-mp="2ztvuhb15m2qm" data-mpi={idx}>
              <div className="font-serif text-4xl md:text-5xl font-bold text-salvia mb-1" data-id="element-154" data-mp="3dru4y5cctf0u">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm uppercase tracking-widest text-gray-500 font-medium" data-id="element-155" data-mp="3sjukb8n6a3wc">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}